import { render } from "./PackageEdit.vue?vue&type=template&id=cdca0080&ts=true"
import script from "./PackageEdit.vue?vue&type=script&lang=ts"
export * from "./PackageEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__